import moment from 'moment'
import debounce from 'debounce'

import { DATE_FORMAT } from '@constants'

import DatePicker from './DatePicker'
import TimePicker from './TimePicker'

export const combineDateAndTime = (date, time) =>
    moment()
        .set({
            hour: time.hour(),
            minute: time.minute(),
            date: date.date(),
            month: date.month(),
            year: date.year(),
        })
        .startOf('minute')

const DateTimePicker = ({
    value,
    onChange = () => {},
    datePickerOptions = {},
    timePickerOptions = {},
    startOfWeek,
}) => {
    const onDateChange = date => {
        if (!!date && !!value) onChange(combineDateAndTime(date, value))
    }

    const onTimeChange = time => {
        if (!!value && !!time) onChange(combineDateAndTime(value, time))
    }

    return (
        <div className="date-time h-100 row no-gutters">
            <div className="col-md-6 pr-md-1 mt-md-auto">
                <DatePicker
                    value={value}
                    onChange={onDateChange}
                    displayFormat={DATE_FORMAT}
                    startOfWeek={startOfWeek}
                    {...datePickerOptions}
                />
            </div>
            <div className="col-md-6 mt-2 mt-md-0">
                <TimePicker value={value} onChange={onTimeChange} {...timePickerOptions} />
            </div>
        </div>
    )
}

export default DateTimePicker
